import React, { useState, Fragment, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, Row, Col, CustomInput, Card } from 'reactstrap';

import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { gAPI_NudgesButtonList, postAPI_Create_A_Message, postAPI_Create_UrlNudgeButton } from '../../../../../../constants/APIs';
import short from 'short-uuid';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import LanguageTabs from '../../../propinfo/components/LanguageTabs/LanguageTabs';
import IntlMessages from '../../../../../../helpers/IntlMessages';
const GreetingCode1 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;
export default function UrlNudgesForm({
    formLabel,
    visible,
    toggle,
    nudgeId,
    integrationLanguages,
    integration,
    locale,
    submit,
    setUrlBasedNudges,
    urlBasedNudges,
    isEditing
}) {
    const [urls, setUrls] = useState('');
    const [displayOrder, setDisplayOrder] = useState(1);


    const [eyeCatcher, setEyeCatcher] = useState({});
    const [greeting, setGreeting] = useState({});

    const [selectedLang, setSelectedLang] = useState(locale);

    const [inputFields, setInputFields] = useState([]);
    const [delayInMilliseconds, setDelayInMilliseconds] = useState('');
    const [delayInMillisecondsInMobile, setDelayInMillisecondsInMobile] = useState('');
    const [disabledInDesktop, setDisabledInDesktop] = useState(false);
    const [disabledInMobile, setDisabledInMobile] = useState(false);
    const [buttons, setButtons] = useState([]);
    const [otherLanguages, setOtherLanguages] = useState([]);
    const LoadNudges = (language) => {

        setInputFields([]);
        setButtons([]);
        setOtherLanguages([]);
        setEyeCatcher({});
        setGreeting({});

        let lang = language;
        if (language === "en") { lang = "en-US"; }
        if (language === "zh-TW") { lang = "hk"; }

        if (!isEditing) {
            setEyeCatcher({
                GroupId: getGroupID(),
                Code: EyeCatcherCode1,
                Language: lang,
                Channel: 'WebsiteDirectLine',
                Default: [],
                Overrides: {},
            });

            setGreeting({
                GroupId: getGroupID(),
                Code: GreetingCode1,
                Language: lang,
                Channel: 'WebsiteDirectLine',
                Default: [],
                Overrides: {},
            });

            if (lang !== "en-US") {
                var other = [...otherLanguages, { code: eyeCatcher?.Code, buttons: buttons, languageCode: lang }];
                setOtherLanguages(other);


            }

        } else {
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_NudgesButtonList}/${integration.id}?group_id=${getGroupID()}&lang=${lang}`,
            }).then((res) => {

                const nudges = res.data.channelDetails.initiationRuleset[0]?.urlBasedNudges?.find(nudge => nudge.id === nudgeId);

                if (lang !== "en-US" && nudges.eyeCatcher === null) {
                    setEyeCatcher({
                        GroupId: getGroupID(),
                        Code: EyeCatcherCode1,
                        Language: lang,
                        Channel: 'WebsiteDirectLine',
                        Default: [],
                        Overrides: {}
                    });

                    if (nudges.otherLanguages !== null) {
                        var other = [...nudges.otherLanguages, { code: EyeCatcherCode1, languageCode: lang }];
                        setOtherLanguages(other);

                    }
                    if (nudges.buttons != null && nudges.buttons.length > 0) {
                        setButtons(nudges.buttons);
                    }
                } else {
                    if (nudges && nudges.eyeCatcher) {
                        setEyeCatcher({

                            GroupId: getGroupID(),
                            Code: nudges.eyeCatcher.query.code && nudges.eyeCatcher.query.code != null ? nudges.eyeCatcher.query.code : EyeCatcherCode1,
                            Language: lang,
                            Channel: 'WebsiteDirectLine',
                            Default: nudges.eyeCatcher != null && nudges.eyeCatcher.response != null ? nudges.eyeCatcher.response.messages : [],
                            Overrides: {}
                        });
                    }
                    else {
                        setEyeCatcher({

                            GroupId: getGroupID(),
                            Code: EyeCatcherCode1,
                            Language: lang,
                            Channel: 'WebsiteDirectLine',
                            Default: [],
                            Overrides: {}
                        });
                    }

                    if (lang !== "en-US") {
                        if (nudges.otherLanguages && nudges.otherLanguages.length > 0) {

                            if (nudges.otherLanguages.filter((o) => o.code === nudges.eyeCatcher?.query.code && o.languageCode === lang).length > 0) {
                                nudges.otherLanguages.filter((o) => o.code === nudges.eyeCatcher?.query.code && o.languageCode === lang)
                                    .map((elem) => {
                                        setInputFields(elem.buttons);
                                    });
                                setOtherLanguages(nudges.otherLanguages);

                            }
                            else {

                                var other = [...nudges.otherLanguages, { code: nudges.eyeCatcher.query.code, languageCode: lang, buttons: [] }];
                                setOtherLanguages(other);

                            }
                        } else {

                            var other = [...nudges.otherLanguages, { code: nudges.eyeCatcher.query.code, languageCode: lang, buttons: [] }];
                            setOtherLanguages(other);

                        }

                        if (nudges.buttons != null && nudges.buttons.length > 0) {
                            setButtons(nudges.buttons);
                        }
                    } else {
                        if (nudges.buttons != null && nudges.buttons.length > 0) {
                            setInputFields(nudges.buttons);
                            setButtons(nudges.buttons);
                        }
                        if (nudges.otherLanguages && nudges.otherLanguages.length > 0) {
                            setOtherLanguages(nudges.otherLanguages);

                        }
                    }
                }
                if (nudges.pageURL != null) {
                    setUrls(nudges.pageURL);
                }
                if (nudges.displayOrder != null) {
                    setDisplayOrder(nudges.displayOrder);
                }
                if (nudges.delayInMilliseconds != null) {
                    setDelayInMilliseconds(nudges.delayInMilliseconds / 1000)
                }
                if (nudges.delayInMillisecondsInMobile != null) {
                    setDelayInMillisecondsInMobile(nudges.delayInMillisecondsInMobile / 1000)
                }
                if (nudges.disabledInDesktop != null) {
                    setDisabledInDesktop(!nudges.disabledInDesktop);
                }
                if (nudges.disabledInMobile != null) {
                    setDisabledInMobile(!nudges.disabledInMobile);
                }

            });
        }

    }
    useEffect(() => {
        LoadNudges(locale);
    }, [locale]);

    const SwitchLanguage = (e) => {
        setSelectedLang(e);
        LoadNudges(e);
    };


    const handleUrlChange = (event) => {
        setUrls(event.target.value);
    };



    const handleInputChangeDelay = (event) => {
        const { name, value } = event.target;
        if (name === "delayInMilliseconds") {
            setDelayInMilliseconds(value);
        } else {
            setDelayInMillisecondsInMobile(value);
        }
    };

    const handleEnabledChange = (event) => {
        const { name, checked } = event.target;
        if (name === "disabledInDesktop") {
            setDisabledInDesktop(checked);
        } else {
            setDisabledInMobile(checked);
        }
    };

    const handleAddFields = () => {
        setInputFields([...inputFields, { text: '', value: '', option: 'OpenURL' }]);
    };

    const handleRemoveFields = (index) => {
        setInputFields(inputFields.filter((_, i) => i !== index));
    };

    const handleInputChange = (index, event) => {
        const values = [...inputFields];
        values[index][event.target.name] = event.target.value;
        setInputFields(values);
    };

    const handleChangeEyeCatcher = (e) => {
        const arr = [e.target.value];
        setEyeCatcher({
            ...eyeCatcher,
            Default: arr,
        });
    };



    const handleSubmit = () => {

        var other = [];
        var button = buttons;
        var lang = selectedLang;

        if (selectedLang === "en") { lang = "en-US"; }
        if (selectedLang === "zh-TW") { lang = "hk"; }
        if (lang !== "en-US") {
            otherLanguages.map((lan) => {
                if (lan.languageCode === lang) {

                    other.push({
                        code: lan.code,
                        buttons: inputFields,
                        languageCode: lan.languageCode
                    })
                } else {

                    other.push({
                        code: lan.code,
                        buttons: lan.buttons,
                        languageCode: lan.languageCode
                    })
                }
            })
        }
        else {
            other = otherLanguages;
            button = inputFields;
        }

        const apiData = {
            id: nudgeId ? nudgeId : null,
            groupId: getGroupID(),
            integrationId: integration.id,
            delayInMilliseconds: (delayInMilliseconds ? parseFloat(delayInMilliseconds) : 0) * 1000,
            delayInMillisecondsInMobile: (delayInMillisecondsInMobile ? parseFloat(delayInMillisecondsInMobile) : 0) * 1000,
            disabledInDesktop: !disabledInDesktop,
            disabledInMobile: !disabledInMobile,
            buttons: button,
            otherLanguages: other,
            languageCode: lang,
            displayOrder: displayOrder,
            pageURL: urls,
        };

        const requestBody = {
            DefaultRuleDescription: "Default",
            DefaultRuleNudges: [
                {
                    EyeCatcher: {
                        Code: EyeCatcherCode1,
                        FilterTags: null,
                    },
                    Greeting: {
                        Code: GreetingCode1,
                        FilterTags: null,
                    },
                    DelayInMilliseconds: (delayInMilliseconds ? parseFloat(delayInMilliseconds) : 0) * 1000,
                    DelayInMillisecondsInMobile: (delayInMillisecondsInMobile ? parseFloat(delayInMillisecondsInMobile) : 0) * 1000,
                    DisabledInDesktop: !disabledInDesktop,
                    DisabledInMobile: !disabledInMobile,
                    Buttons: button,
                    OtherLanguages: other,
                    LanguageCode: lang,
                    DisplayOrder: displayOrder,
                    PageURL: urls,
                }
            ]
        };

        if (!isEditing) {

            AxiosAPI({
                method: 'post',
                url: postAPI_Create_A_Message,
                data: greeting,
            })
                .then(response => console.log('Greeting created successfully', response))
                .catch(error => console.error('Error creating Greeting:', error));

            AxiosAPI({
                method: 'post',
                url: postAPI_Create_A_Message,
                data: eyeCatcher,
            })
                .then(response => console.log('EyeCatcher created successfully', response))
                .catch(error => console.error('Error creating EyeCatcher:', error));

            AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_UrlNudgeButton}/${integration.id}?group_id=${getGroupID()}`,
                data: requestBody,
            })
                .then((response) => {
                    const newNudgeData = {
                        id: nudgeId || '',
                        pageURL: urls,
                        displayOrder,
                        delayInMilliseconds,
                        delayInMillisecondsInMobile,
                        disabledInDesktop,
                        disabledInMobile,
                        buttons: button,
                        otherLanguages: other,
                        eyeCatcher: { response: { messages: eyeCatcher.Default } },
                        greeting: { response: { messages: greeting.Default } },
                    };
                    setUrlBasedNudges(prevNudges => [...prevNudges, newNudgeData]);
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                    toggle();
                })
                .catch((error) => {
                    console.error('Error during API call:', error);
                });
        } else {

            const eyeCatcherData = eyeCatcher;

            submit(eyeCatcherData, apiData);
        }

    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg" backdrop="static">
                <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Card className="p-4">
                        <Colxx xxs="12" className="px-0">
                            <Row className="text-left mb-4">
                                <LanguageTabs
                                    integrationLanguages={integrationLanguages}
                                    selectedTab={selectedLang}
                                    setLanguage={(e) => SwitchLanguage(e)}
                                ></LanguageTabs>
                                <Colxx sm={12} className="mt-3">
                                    <h6>Eye Catcher</h6>
                                    <Input
                                        type="text"
                                        value={eyeCatcher?.Default}
                                        onChange={handleChangeEyeCatcher}
                                        name="name"
                                    />
                                </Colxx>
                            </Row>
                            <Row className="text-left mb-3">
                                <Colxx sm={12}>
                                    <h6>URL(s)</h6>
                                    <Separator className="mb-2" />
                                </Colxx>
                                <Colxx sm={8}>
                                    <Label>URL starts with</Label>
                                    <textarea
                                        rows={2}
                                        value={urls}
                                        onChange={handleUrlChange}
                                        placeholder="Enter URL(s) separated by commas"
                                        className='textarea-style'
                                    />
                                </Colxx>
                                <Colxx sm={3} className="mt-2">
                                    <Label><IntlMessages id='dashboards.displayOrder' /></Label>
                                    <Input
                                        type="number"
                                        value={displayOrder}
                                        onChange={(e) => setDisplayOrder(e.target.value)}
                                        placeholder="Display Order"
                                    />
                                </Colxx>
                            </Row>
                            <Row className="text-left mb-4">
                                <Colxx xxs="12">
                                    <h6>Desktop</h6>
                                    <Separator className="mb-2" />
                                </Colxx>
                                <Colxx sm={4}>
                                    <Label>Delay in Seconds</Label>
                                    <Input
                                        type="number"
                                        value={delayInMilliseconds || ''}
                                        onChange={handleInputChangeDelay}
                                        name="delayInMilliseconds"
                                    />
                                </Colxx>
                                <Colxx sm={4} className="mt-2">
                                    <CustomInput
                                        className="mt-4"
                                        id="disabledInDesktop"
                                        type="checkbox"
                                        label="Enabled (Desktop)"
                                        checked={disabledInDesktop}
                                        name="disabledInDesktop"
                                        onChange={handleEnabledChange}
                                    />
                                </Colxx>
                            </Row>
                            <Row className="text-left mb-4">
                                <Colxx xxs="12">
                                    <h6>Mobile</h6>
                                    <Separator className="mb-2" />
                                </Colxx>
                                <Colxx sm={4}>
                                    <Label>Delay in Seconds</Label>
                                    <Input
                                        type="number"
                                        value={delayInMillisecondsInMobile || ''}
                                        onChange={handleInputChangeDelay}
                                        name="delayInMillisecondsInMobile"
                                    />
                                </Colxx>
                                <Colxx sm={4} className="mt-2">
                                    <CustomInput
                                        className="mt-4"
                                        id="disabledInMobile"
                                        type="checkbox"
                                        label="Enabled (Mobile)"
                                        checked={disabledInMobile}
                                        name="disabledInMobile"
                                        onChange={handleEnabledChange}
                                    />
                                </Colxx>
                            </Row>
                            <Row className="text-left">
                                <Colxx sm={12}>
                                    <h6>Buttons</h6>
                                    <Separator className="" />
                                </Colxx>
                                {inputFields.map((nudge, index) => (
                                    <div key={index} className="d-flex mt-3">
                                        <Colxx sm={3}>
                                            <Label>Text</Label>
                                            <Input
                                                type="text"
                                                name="text"
                                                value={nudge.text}
                                                onChange={event => handleInputChange(index, event)}
                                            />
                                        </Colxx>
                                        <Colxx sm={4}>
                                            <Label>Option</Label>
                                            <Input
                                                type="select"
                                                name="option"
                                                value={nudge.option}
                                                onChange={event => handleInputChange(index, event)}
                                            >
                                                <option value={"None"}>Select</option>
                                                <option value={"OpenMenuItem"}>Open Menu Item</option>
                                                <option value={"SendToChatbot"}>Send to Chatbot</option>
                                                <option value={"OpenURL"}>Open URL</option>
                                            </Input>
                                        </Colxx>
                                        <Colxx sm={4}>
                                            <Label>Value</Label>
                                            <Input
                                                type="text"
                                                name="value"
                                                value={nudge.value}
                                                onChange={event => handleInputChange(index, event)}
                                            />
                                        </Colxx>
                                        <Colxx sm={1}>
                                            <Label>Remove</Label>
                                            <div>
                                                <Button
                                                    onClick={() => handleRemoveFields(index)}
                                                    color="secondary"
                                                    size="xs"
                                                    outline
                                                    className="mt-1"
                                                >
                                                    X
                                                </Button>
                                            </div>
                                        </Colxx>
                                    </div>
                                ))}
                            </Row>
                            <Button
                                onClick={handleAddFields}
                                color="primary"
                                size="xs"
                                outline
                                className="mt-3"
                            >
                                + Add Button
                            </Button>
                        </Colxx>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" size='xs' onClick={handleSubmit}>Update</Button>
                    <Button color="secondary" size='xs' onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Modal >
        </Fragment >
    );
}
